import React, {Component} from "react"

import {Body} from "@irati/ui/src/Typography"
import ModeratedRecognitionMessage from "@irati-web/recognition/src/components/Popup/shared/ModeratedRecognitionMessage"
import {Poll, Recognition} from "@irati/types"

interface Props {
  poll?: Poll
  recognition?: Recognition
}

class Message extends Component<Props> {
  render() {
    const {poll, recognition} = this.props
    if (recognition) {
      return <ModeratedRecognitionMessage recognition={recognition} />
    }

    if (poll) {
      return (
        <Body small marginBottom={1}>
          {poll.desc}
        </Body>
      )
    }

    return null
  }
}

export default Message
